var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"link",attrs:{"href":"#"},on:{"click":_vm.changeClient}},[_vm._v(" "+_vm._s(_vm.item.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }